<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-11-11 09:53:01
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2024-06-07 14:35:17
-->
<template>
  <div class="innovative innovative-accuffrivus" :class="{textj: language != 'en'}" ref="accuffrivus">
    <div class="innovative-bj scrollBox">
      <img class="wid100" :src="require('@/assets/images/pc/innovate/product-list-bj.png')" alt="" srcset="">
      <div class="innovative-bj-title center_up_down_left_right" v-html="$t('product.accuffrivus.title')"></div>
    </div>
    <div class="p-t-60 overhid">
      <div class="innovative-container">
        <div class="innovative-wrap-item flex p-b-150" :class="{align_items_center: language != 'en'}">
          <div class="flex_1">
            <img class="" :src="$t('product.accuffrivus.list[0].img')" alt="" srcset="">
          </div>
          <div class="flex_1 p-l-80 p-b-30">
            <div class="innovative-item-title" v-html="$t('product.accuffrivus.list[0].title')"></div>
            <div class="p-t-15 textj">
              <p class="p-b-30" v-for="item, index in $t('product.accuffrivus.list[0].des')" :key="index" v-html="item"></p>
            </div>
          </div>
        </div>
      </div>
      <div class="accuffrivus-advantages innovative-wrap-item">
        <div class="innovative-container">
          <div class="trans-list p-b-88">
            <div class="innovative-item-title p-l-15" style="" v-html="$t('product.accuffrivus.list[1].title')"></div>
            <div class="p-t-50 flex justify_content_center">
              <img class="" :src="$t('product.accuffrivus.list[1].img')" alt="" srcset="">
            </div>
          </div>
          <div class="innovative-accuffrivus-m-h innovative-characteristics trans-list">
            <div class="flex_1 flex flex_col justify_content_center">
              <div class="flex">
                <div :class="['flex_1 flex flex_col align_items_center']" v-for="item, index in $t('product.accuffrivus.list[2].des')" :key="index" :style="language == 'en' ? 'padding: 0 2%;' : 'padding: 0 8%;'">
                  <div :class="['flex flex_col align_items_center', index == 1 && clientWidth > 1680 ? 'p-r-40' : '']">
                    <div :class="index == 1 ? 'p-b-6' : ''">
                      <img class="" :src="item.img" alt="" srcset="">
                    </div>
                    <template v-if="language == 'en'">
                      <div v-if="clientWidth <= 1360 || clientWidth >= 2370" class="innovative-wrap-item-title textc fz-22 p-b-20 p-t-15" v-html="item.title.join(' ')"></div>
                      <div v-else class="innovative-wrap-item-title textc fz-22 p-b-20 p-t-15">
                        <p v-for="$item, $index in item.title" :key="$index" v-html="$item"></p>
                      </div>
                    </template>
                    <template v-else>
                      <div class="innovative-wrap-item-title textc fz-22 p-b-20 p-t-15">
                        <p v-for="$item, $index in item.title" :key="$index" v-html="$item"></p>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
              <div class="flex">
                <div :class="['flex_1 flex flex_col align_items_center']" v-for="item, index in $t('product.accuffrivus.list[2].des')" :key="index" :style="language == 'en' ? 'padding: 0 2%;' : 'padding: 0 8%;'">
                  <div>
                    <p class="innovative-characteristics-item" v-for="$item, $index in item.list" :key="$index" v-html="$item"></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="innovative-container">
        <div class="innovative-wrap-item p-t-50 article">
          <div class="innovative-item-title p-l-15" v-html="$t('product.accuffrivus.article.title')"></div>
          <div class="p-t-15">
            <p class="p-t-15" v-for="item, index in $t('product.accuffrivus.article.des')" :key="index" v-html="`${index + 1}. ${item}`"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters(['language', 'clientWidth'])
  }
}
</script>

<style lang="less">
@import "~@/styles/pc/products.less";
</style>

<style lang="less" scoped>
.pc .innovative-accuffrivus {
  padding-bottom: 50PX;
  .innovative-characteristics {
    padding: 50PX 65PX;
  }
  .accuffrivus-advantages {
    background: #F8FBFF;
    padding: 50PX 0;
    .innovative-item-title {
      width: 298PX;
      height: 45PX;
      background: linear-gradient(270deg, #FFFFFF 0%, #008CDF 50%, rgba(0,192,241,0) 100%);
      text-align: center;
      margin: 0 auto;
    }
  }
  .innovative-accuffrivus-m-h {
    background: #FFFFFF;
    box-shadow: 0PX 4PX 12PX 4PX rgba(81, 170, 255, 0.1);
  }
}
</style>
